<template>
  <div>
    <Form @submit.native.prevent="preventSubmit">
      <FormItem prop="keyword" label="查询：" :label-width="60" style="width: 320px;">
        <Input type="text" v-model="keyword" @on-enter="queryRoomListWithKeyword" placeholder="请输入查询关键字"></Input>
      </FormItem>
      <FormItem prop="allSelect">
        <Button type="primary" @click="selectedAll">全选</Button>
      </FormItem>
    </Form>
    <Table stripe ref="tableSelection" :loading="loading" @on-selection-change="selectedChangeWithRow" :columns="columns" :data="displayData" class="hidden-header-selection"></Table>
    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="count" :current="page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <Row>
      <Col>{{`共${filterDataList.length}房，已选择${selectedRoomId.size}房`}}</Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      keyword: '',
      loading: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: "房间ID",
          key: "roomId",
          align: "center",
          width: 250
        },
        {
          title: "房间号",
          key: "custRoomNo",
          align: "center",
          width: 250
        },
        {
          title: "房间地址",
          key: "custRoomAddr",
          align: "center",
          width: 450
        },
      ],
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      displayData: [],
      filterDataList: [],
      selectedRoomId: new Set()
    }
  },
  methods: {
    queryRoomListWithKeyword() {

    },
    // 查询未打包房间列表
    initRoomList() {
      this.loading = true;
      this.count = this.data.length;
      this.pageCount = (this.count % this.page) == 0 ? (this.count / this.page) : (this.count / this.page + 1)
      this.filterDataList = this.data;
      this.displayRoomList();
      this.loading = false;
    },
    // 展示当前页数的未打包房间
    displayRoomList() {
      let startIndex = (this.page-1) * this.pageSize;
      let endIndex = this.pageSize * this.page;
      this.displayData = [];
      if (this.count<=5) {
        this.displayData = this.filterDataList
      } else {
        let filterDataList = [];
        for (let i=startIndex; i<endIndex; i++) {
          if (!this.filterDataList[i]) break;
          filterDataList.push(this.filterDataList[i]);
        }
        this.displayData = filterDataList;
      }
    },
    // 前端查询
    queryDataWithKeyword() {
      this.loading = true;
      this.filterDataList = this.filterDataWithKeyword();
      this.page = 1;
      this.count = this.filterDataList.length;
      this.pageCount = (this.count % this.filterDataList.length) == 0 ? (this.count / this.filterDataList.length) : (this.count / this.filterDataList.length + 1)
      this.displayRoomList();
      this.loading = false;

      this.$nextTick(() => {
        this.selectedChange();
      })
    },
    // 前端筛选
    filterDataWithKeyword() {
      let self = this;
      return this.data.filter(function (room){
        let result = false;
        for (let itemKey in room) {
          if (self.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + room[itemKey];
          if (queryItem.toUpperCase().indexOf((self.keyword).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'flag':
        case 'custRoomName':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    // 单行选择
    selectedChangeWithRow() {
      let length = Object.keys(this.$refs.tableSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.tableSelection.objData[i].roomId;
        let isChecked = this.$refs.tableSelection.objData[i]._isChecked;
        if (!isChecked&&this.selectedRoomId.has(roomId)) {
          this.selectedRoomId.delete(roomId);
        } else if (isChecked&&!this.selectedRoomId.has(roomId)) {
          this.selectedRoomId.add(roomId);
        }
      }
      this.updateSelectedRoomId();
    },
    // 选择全部
    selectedAll() {
      for (let i=0; i<this.filterDataList.length; i++) {
        this.selectedRoomId.add(this.filterDataList[i].roomId);
      }
      this.selectedChange();
    },
    // 选择后样式变化
    selectedChange() {
      let length = Object.keys(this.$refs.tableSelection.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.tableSelection.objData[i].roomId;
        if (this.selectedRoomId.has(roomId)) {
          this.$refs.tableSelection.objData[i]._isChecked = true;
        } else {
          this.$refs.tableSelection.objData[i]._isChecked = false;
        }
      }
      this.updateSelectedRoomId();
    },
    // 更新选择未打包房间的数据
    updateSelectedRoomId() {
      this.selectedRoomId = new Set(this.selectedRoomId);
    },
    changePage(pageIndex) {
      this.page = pageIndex;
      this.displayRoomList();

      this.$nextTick(() => {
        this.selectedChange();
      })
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.displayRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
}
</script>

<style lang="scss">
.hidden-header-selection .ivu-table .ivu-table-header th.ivu-table-column-center div.ivu-table-cell .ivu-checkbox-wrapper{
  display:none;
}
</style>





// WEBPACK FOOTER //
// src/pages/room/room-detail/room-list.vue